import { TIndexSizeErrorFactory } from '../types';

export const createIndexSizeError: TIndexSizeErrorFactory = () => new DOMException('', 'IndexSizeError');
